import React from 'react';
import { Block } from '../../../../../../components';
import Spinner from '../../../../../../components/Spinner';
import {
  TextTitle,
  ToggleHeader
} from '../../../certificates-constancies/type1/register/components';
import {
  ContainerProcedure,
  ButtonBack
} from '../../ChangeCareerCampusModality/info/components';
import Step from '../../UpdatePhoto/Register/components/Step';
import { ProcedureInfoComponent } from '../info/components/ProcedureInfoComponent';
import { RequestStatusResponse, MessageHelp, SummaryData } from './components';
import { SubContainer } from '../../../certificates-constancies/type1/info/components';

const ChangeStudiesOptionProgressView = (props: any) => {
  const {
    isLoading,
    request,
    procedure,
    handlerBackButton,
    handlerRedirectPage
  } = props;

  const inProcess = request?.status?.status === 'PEND_PROCESO';
  return (
    <ContainerProcedure>
      {isLoading && <Spinner />}
      {request && !isLoading && (
        <SubContainer>
          <ButtonBack onClick={handlerBackButton} />
          <ToggleHeader
            name={procedure?.name}
            amount={procedure?.amount}
            duration={procedure?.duration}
            date={procedure?.endDate}
            // pin1={procedure?.pin1}
            status={request?.status}
            childContent={
              <ProcedureInfoComponent
                inRegister
                // applySince={procedure?.detail?.applySince}
              />
            }
          />
          <TextTitle title="Progreso" />
          <Block customized maxWidth="100%" padding="28px 0px 0px 8px">
            <Step
              isFirst
              name={procedure.steps[0].name}
              order={procedure.steps[0].order}
              date={procedure.steps[0].date?.toLowerCase()}
              isComplete={procedure.steps[0].isComplete}
              isCurrent={procedure.steps[0].isCurrent}
            >
              <SummaryData
                abstract={
                  procedure.detail.newAcademicData.studiesOption.careerName
                }
                shift={
                  procedure.detail.newAcademicData.shiftDesc?.toLowerCase() ||
                  ''
                }
                newPeriod={procedure?.detail?.applySince}
                newCampus={procedure?.detail?.destinationCampus}
              />
            </Step>
            <Step
              name={procedure.steps[1].name}
              order={procedure.steps[1].order}
              isComplete={!inProcess}
              isCurrent={procedure.steps[1].isCurrent}
              isLast
            >
              <>
                <RequestStatusResponse
                  currentCareer={
                    procedure.detail.currentAcademicData.studiesOption
                      .careerName
                  }
                  newCareer={
                    procedure.detail.newAcademicData.studiesOption.careerName
                  }
                  requestDate={procedure.steps[1].date?.toLowerCase()}
                  isAccepted={request?.status?.status === 'PROCEDE'}
                  comentary={request?.comentary}
                  applySince={procedure?.detail?.applySince?.toLowerCase()}
                  inProcess={inProcess}
                />
              </>
              <div style={{ marginTop: '24px' }}>
                <MessageHelp onClick={handlerRedirectPage} />
              </div>
            </Step>
          </Block>
        </SubContainer>
      )}
    </ContainerProcedure>
  );
};

export default ChangeStudiesOptionProgressView;
